<template>
  <div class="main">
    <div class="header">
      <div class="left">
        <i-button @click="GoBack">返回</i-button>
        <span class="title">{{ evaluationName || '试卷报告' }}</span>
      </div>
      <div class="filter">
        <Select
          v-model="groupId"
          style="width:320px;"
          @on-change="OnGroupChange"
        >
          <Option :value="0">全部下发班级</Option>
          <Option
            v-for="g in groupOptions"
            :key="g.send_id"
            :value="g.group_id"
          >{{ FormatGroupOption(g) }}</Option>
        </Select>
        <i-button
          type="primary"
          icon="ios-download-outline"
          :loading="exporting"
          style="margin-left:12px;"
          @click="ExportCsv"
        >批量导出</i-button>
      </div>
    </div>
    <div class="content">
      <i-table border :columns="columns" :data="list"/>
    </div>
    <div class="footer">
      <Page
        :total="count"
        :page-size="pageSize"
        :current="currentPage"
        :page-size-opts="[10,20,50]"
        show-total
        show-elevator
        show-sizer
        @on-change="ChangePage"
        @on-page-size-change="ChangePageSize"
      />
    </div>

    <Modal
      v-model="detailVisible"
      title="答题详情"
      class-name="vertical-center-modal"
      :width="780"
      footer-hide
    >
      <Spin size="large" fix v-if="detailLoading"/>
      <div v-if="detail" class="detail">
        <!-- 顶部信息条 -->
        <div class="detail-head">
          <div class="head-row">
            <span class="hi"><i class="label">学生：</i>{{ (detail.record && detail.record.nickname) || '-' }}</span>
            <span class="hi"><i class="label">总分：</i><b class="score">{{ scorePercent }}</b><i class="unit">分</i></span>
            <span class="hi" v-if="detail.record && detail.record.use_time"><i class="label">用时：</i>{{ FormatUseTime(detail.record.use_time) }}</span>
          </div>
          <div class="advise" v-if="detail.record && detail.record.advise">
            <div class="advise-title">总结与建议</div>
            <div class="advise-text">{{ detail.record.advise }}</div>
          </div>
        </div>

        <!-- 题号导航 -->
        <div class="nav-title">评测项目</div>
        <div class="qnav">
          <span
            v-for="(q, i) in (detail.details || [])"
            :key="i"
            class="qdot"
            :class="{ active: i === currentIndex }"
            @click="currentIndex = i"
          >{{ q.sort || (i + 1) }}</span>
        </div>

        <!-- 选中题目详情 -->
        <div class="qpanel" v-if="currentDetail">
          <div class="qpanel-title">
            第{{ currentDetail.sort || (currentIndex + 1) }}题
            <span v-if="currentDetail.type_name"> · {{ currentDetail.type_name }}</span>
          </div>
          <div class="qpanel-desc" v-if="currentDetail.question_desc">{{ currentDetail.question_desc }}</div>

          <!-- 题目内容 -->
          <div class="qcontent">
            <div class="qword" v-if="currentDetail.word">
              <b>{{ currentDetail.word }}</b>
              <span v-if="currentDetail.meaning" class="meaning">（{{ currentDetail.meaning }}）</span>
            </div>
            <div class="qsentence" v-if="currentDetail.sentence">{{ currentDetail.sentence }}</div>
            <div class="qquestion" v-if="currentDetail.question">{{ currentDetail.question }}</div>
            <div class="qpic" v-if="currentDetail.pic"><img :src="currentDetail.pic" /></div>
          </div>

          <!-- 我的录音 -->
          <div class="qrecord">
            <div class="qrecord-label">我的录音</div>
            <audio
              v-if="currentDetail.audio"
              :src="currentDetail.audio"
              controls
              class="qaudio"
            />
            <div class="qrecord-empty" v-else>暂无录音</div>
          </div>

          <!-- 分值 / 得分 -->
          <div class="qscore">
            <span><i class="label">分值：</i>{{ currentDetail.question_score || 0 }}</span>
            <span style="margin-left:32px;"><i class="label">学生得分：</i><b>{{ currentDetail.user_score || 0 }}</b></span>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import evaluationApi from '@/lib/api/evaluation'
import { DateFormat } from '@lib/common.js'

export default {
  name: 'EvaluationReport',
  data() {
    return {
      hopeEvaluationId: '',
      evaluationName: '',
      groupId: 0,
      groupOptions: [],
      start: 0,
      pageSize: 10,
      currentPage: 1,
      count: 0,
      list: [],
      detailVisible: false,
      detailLoading: false,
      exporting: false,
      detail: null,
      currentIndex: 0,
      columns: [
        { title: '学生', key: 'nickname' },
        { title: '班级', key: 'group_name' },
        {
          title: '状态',
          key: 'is_finish',
          width: 90,
          align: 'center',
          render: (h, params) => {
            const finish = Number(params.row.is_finish) === 1
            return h('span', {
              style: { color: finish ? '#19be6b' : '#ed4014' }
            }, finish ? '已完成' : '未完成')
          }
        },
        {
          title: '总分',
          key: 'user_total_score',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', Number(params.row.is_finish) === 1 ? this.RowPercent(params.row) : '-')
          }
        },
        {
          title: '完成时间',
          width: 170,
          render: (h, params) => {
            const t = params.row.finish_time
            return h('span', t ? DateFormat(t * 1000, 'yyyy-MM-dd hh:mm') : '-')
          }
        },
        {
          title: '操作',
          width: 110,
          align: 'center',
          render: (h, params) => {
            const finish = Number(params.row.is_finish) === 1
            return h('i-button', {
              props: { type: 'primary', size: 'small', disabled: !finish },
              on: { click: () => this.OpenDetail(params.row) }
            }, '查看详情')
          }
        }
      ]
    }
  },
  computed: {
    currentDetail() {
      const list = (this.detail && this.detail.details) || []
      return list[this.currentIndex] || null
    },
    // 百分制总分 = user_total_score × 100 / 整卷满分(各题 question_score 之和)
    scorePercent() {
      if (!this.detail) return '0.00'
      const got = Number((this.detail.record && this.detail.record.user_total_score) || 0)
      const full = (this.detail.details || []).reduce((sum, q) => sum + Number(q.question_score || 0), 0)
      if (!full) return '0.00'
      return (got * 100 / full).toFixed(2)
    }
  },
  created() {
    this.hopeEvaluationId = this.$route.query.hope_evaluation_id || ''
    this.evaluationName = this.$route.query.evaluation_name || ''
    if (!this.hopeEvaluationId) {
      this.$Message.error('缺少试卷参数')
      return
    }
    this.LoadGroups()
    this.GetList()
  },
  methods: {
    LoadGroups() {
      evaluationApi.SendGroupListForReport({
        hopeEvaluationId: this.hopeEvaluationId
      }).then(res => {
        if (res.status == 1) {
          this.groupOptions = res.data || []
        } else {
          this.$Message.error(res.msg || '获取下发班级失败')
        }
      })
    },
    GetList() {
      evaluationApi.ReportGroupSummary({
        hopeEvaluationId: this.hopeEvaluationId,
        groupId: this.groupId || 0,
        start: this.start,
        rows: this.pageSize
      }).then(res => {
        if (res.status == 1) {
          this.list = res.data.list || []
          this.count = res.data.total || 0
        } else {
          this.$Message.error(res.msg || '获取学生列表失败')
        }
      })
    },
    OnGroupChange() {
      this.start = 0
      this.currentPage = 1
      this.GetList()
    },
    ChangePage(index) {
      this.currentPage = index
      this.start = (index - 1) * this.pageSize
      this.GetList()
    },
    ChangePageSize(size) {
      this.pageSize = size
      this.start = 0
      this.currentPage = 1
      this.GetList()
    },
    OpenDetail(row) {
      this.detail = null
      this.currentIndex = 0
      this.detailLoading = true
      this.detailVisible = true
      evaluationApi.ReportStudentDetail({
        recordId: row.record_id
      }).then(res => {
        this.detailLoading = false
        if (res.status == 1) {
          const record = res.data.record || {}
          record.nickname = row.nickname
          record.user_total_score = row.user_total_score
          this.detail = {
            record,
            details: res.data.details || []
          }
        } else {
          this.$Message.error(res.msg || '获取详情失败')
          this.detailVisible = false
        }
      }).catch(() => {
        this.detailLoading = false
        this.$Message.error('获取详情失败')
        this.detailVisible = false
      })
    },
    FormatUseTime(sec) {
      const s = Number(sec) || 0
      if (!s) return '-'
      const m = Math.floor(s / 60)
      const r = s % 60
      const pad = n => (n < 10 ? '0' + n : '' + n)
      return `${pad(m)}分${pad(r)}秒`
    },
    GoBack() {
      this.$router.push({ name: 'evaluationList' })
    },
    FormatGroupOption(g) {
      const fmt = t => t ? DateFormat(t * 1000, 'MM-dd hh:mm') : '-'
      return `${g.group_name} (${fmt(g.start_time)} ~ ${fmt(g.end_time)})`
    },
    // 行百分制得分 = user_total_score × 100 / total_score(整卷满分)，无满分则回退原始分
    RowPercent(row) {
      const full = Number(row.total_score || row.full_score || 0)
      const got = Number(row.user_total_score || 0)
      if (!full) return got
      return (got * 100 / full).toFixed(2)
    },
    // 批量导出：按当前班级筛选拉全量数据，前端生成 CSV(带 BOM，Excel 中文不乱码)
    ExportCsv() {
      this.exporting = true
      evaluationApi.ReportGroupSummary({
        hopeEvaluationId: this.hopeEvaluationId,
        groupId: this.groupId || 0,
        start: 0,
        rows: 99999
      }).then(res => {
        this.exporting = false
        if (res.status != 1) {
          this.$Message.error(res.msg || '导出失败')
          return
        }
        const rows = (res.data && res.data.list) || []
        if (!rows.length) {
          this.$Message.warning('暂无数据可导出')
          return
        }
        this.DownloadCsv(rows)
      }).catch(() => {
        this.exporting = false
        this.$Message.error('导出失败')
      })
    },
    DownloadCsv(rows) {
      const headers = ['学生', '班级', '状态', '总分(百分制)', '完成时间']
      const esc = v => {
        const s = (v === null || v === undefined) ? '' : String(v)
        return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
      }
      const lines = [headers.join(',')]
      rows.forEach(r => {
        const finish = Number(r.is_finish) === 1
        lines.push([
          esc(r.nickname),
          esc(r.group_name),
          esc(finish ? '已完成' : '未完成'),
          esc(finish ? this.RowPercent(r) : '-'),
          esc(r.finish_time ? DateFormat(r.finish_time * 1000, 'yyyy-MM-dd hh:mm') : '-')
        ].join(','))
      })
      const csv = '﻿' + lines.join('\r\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      const name = (this.evaluationName || '测评报告').replace(/[\\/:*?"<>|]/g, '_')
      const stamp = DateFormat(Date.now(), 'yyyyMMddhhmm')
      a.href = url
      a.download = `${name}_${stamp}.csv`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
      this.$Message.success(`已导出 ${rows.length} 条`)
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  padding: 18px;
  box-sizing: border-box;
  background: #f3f3f3;
  .header {
    width: 100%;
    height: 48px;
    background: #fff;
    padding: 9px 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    .left {
      display: flex;
      align-items: center;
      .title {
        margin-left: 12px;
        font-size: 15px;
        font-weight: 600;
      }
    }
  }
  .content {
    width: 100%;
    background: #fff;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .footer {
    height: 80px;
    width: 100%;
    background: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 24px 10px;
    box-sizing: border-box;
  }
}
.detail {
  position: relative;
  min-height: 160px;
  .detail-head {
    margin-bottom: 16px;
    font-size: 14px;
    .head-row {
      display: flex;
      align-items: center;
      .hi {
        margin-right: 28px;
        .label { color: #999; font-style: normal; }
        .score { color: #19be6b; font-size: 18px; }
        .unit { color: #19be6b; font-size: 13px; font-style: normal; margin-left: 1px; }
      }
    }
    .advise {
      margin-top: 12px;
      padding: 12px 14px;
      background: #f6ffed;
      border-radius: 8px;
      .advise-title {
        font-weight: 600;
        margin-bottom: 6px;
        color: #333;
      }
      .advise-text {
        font-size: 13px;
        color: #555;
        line-height: 1.6;
      }
    }
  }
  .nav-title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .qnav {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #eee;
    .qdot {
      width: 40px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 50%;
      background: #f0f0f0;
      color: #666;
      cursor: pointer;
      font-size: 15px;
      user-select: none;
      transition: all 0.15s;
      &:hover { background: #e0f5e9; }
      &.active {
        background: #19be6b;
        color: #fff;
      }
    }
  }
  .qpanel {
    .qpanel-title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 6px;
    }
    .qpanel-desc {
      font-size: 13px;
      color: #888;
      line-height: 1.6;
      margin-bottom: 12px;
    }
    .qcontent {
      margin-bottom: 14px;
      .qword {
        b { font-size: 20px; color: #1890ff; }
        .meaning { color: #999; font-size: 14px; }
      }
      .qsentence, .qquestion {
        font-size: 15px;
        line-height: 1.6;
        margin-top: 4px;
      }
      .qpic img {
        max-width: 240px;
        max-height: 160px;
        border-radius: 6px;
        margin-top: 8px;
      }
    }
    .qrecord {
      padding: 14px;
      background: #fafafa;
      border-radius: 8px;
      margin-bottom: 12px;
      .qrecord-label {
        font-size: 13px;
        color: #666;
        margin-bottom: 8px;
      }
      .qaudio { width: 100%; }
      .qrecord-empty { color: #999; font-size: 13px; }
    }
    .qscore {
      font-size: 14px;
      .label { color: #999; font-style: normal; }
      b { color: #19be6b; font-size: 16px; }
    }
  }
}
</style>
